import { Shield, Eye, UserCog, User } from 'lucide-react';

interface RoleBadgeProps {
  role: string;
}

const roleConfig: Record<string, { label: string; icon: typeof Shield; className: string }> = {
  // Lowercase versions
  super_admin: {
    label: 'Super Admin',
    icon: Shield,
    className: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
  },
  admin: {
    label: 'Admin',
    icon: UserCog,
    className: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400',
  },
  viewer: {
    label: 'Viewer',
    icon: Eye,
    className: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400',
  },
  // Uppercase versions (from API)
  SUPER_ADMIN: {
    label: 'Super Admin',
    icon: Shield,
    className: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400',
  },
  TENANT_ADMIN: {
    label: 'Tenant Admin',
    icon: UserCog,
    className: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400',
  },
  TENANT_USER: {
    label: 'Tenant User',
    icon: User,
    className: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400',
  },
};

const defaultConfig = {
  label: 'Unknown',
  icon: User,
  className: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400',
};

export function RoleBadge({ role }: RoleBadgeProps) {
  const config = roleConfig[role] || defaultConfig;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${config.className}`}
    >
      <Icon className="w-3 h-3" />
      {config.label}
    </span>
  );
}
